export const STATUS_LABELS: Record<string, string> = {
  confirmed: "Confirmado",
  pending: "Pendente",
  cancelled: "Cancelado",
};

export const BATCH_STATUS_LABELS: Record<string, string> = {
  PROCESSING: "Processando",
  SUCCESS: "Sucesso",
  FAIL: "Falha",
};

export const EMPTY = "—";

export const formatCpf = (cpf?: string | null) =>
  cpf
    ? cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4")
    : EMPTY;

export const formatDateTime = (date?: string | null) =>
  date
    ? new Date(date).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      })
    : EMPTY;

export const formatCents = (cents?: number | null) =>
  typeof cents === "number"
    ? (cents / 100).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      })
    : EMPTY;

export const orEmpty = (value?: string | null) =>
  value && value.trim() !== "" ? value : EMPTY;

// Formatos da exportação em CSV: nulo vira célula vazia, nunca EMPTY.
const pad2 = (value: number) => value.toString().padStart(2, "0");

export const formatDateTimeCsv = (date?: string | null) => {
  if (!date) return "";
  const d = new Date(date);
  return `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};

export const formatCentsCsv = (cents?: number | null) =>
  typeof cents === "number"
    ? (cents / 100).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "";

export const formatDateIso = (date: Date) =>
  `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
